import { useEffect, useRef, useState } from 'react';
import { ArrowLeftIcon } from '@/assets/ArrowLeft';
import { Input } from '../../../components/ui/input';
import { cn } from '../../../lib/utils';
import { BackButtonHide } from '../../../utils/BackButton';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { XIcon } from '@/assets/X';
import { useGetMenu } from '../services/getMenu';
import { useProductSearch } from '../services/useProductSearch';
import { FoodHomeCard } from '../../pickup/ui/component/FoodCard';
import { IMenuList } from '../types/Menu';
import { useGetNearesBranch } from '../../addresses/services/getNearBranch';

export const Search = () => {
  const { t } = useTranslation();

  BackButtonHide();
  const inputRef = useRef<HTMLInputElement>(null);
  const [scrolled, setScrolled] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const { nearest } = useGetNearesBranch();
  const { menu } = useGetMenu(nearest?.branch_id);
  const { searchResults, isSearching } = useProductSearch(nearest?.branch_id, debouncedSearch);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchValue);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchValue]);

  const displayMenu: IMenuList[] = debouncedSearch.trim() ? searchResults : menu;

  useEffect(() => {
    const scrollElement = document.getElementById('scrollable');
    if (!scrollElement) return;

    const handleScroll = () => {
      setScrolled(scrollElement.scrollTop > 100);
    };

    scrollElement.addEventListener('scroll', handleScroll);
    return () => {
      scrollElement.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="flex flex-col gap-[18px] flex-1">
      <div
        className={cn(
          // Светлая шапка, как на главной: поле белое на фоне страницы.
          'flex sticky top-0 bg-fill-background z-50 flex-row gap-[12px] items-center px-4 justify-between w-full pt-2 pb-2'
        )}
      >
        <div
          className={`origin-right transition-transform duration-700 ease-in-out ${
            scrolled ? 'scale-x-100' : 'scale-x-100'
          } w-full`}
        >
          <Input
            ref={inputRef}
            className="shadow-none border-none bg-white rounded-xl h-9 w-full"
            placeholder={t('search')}
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            iconLeft={
              <ArrowLeftIcon
                className="text-text-icon-secondary"
                onClick={() => navigate('/')}
              />
            }
            iconRight={
              searchValue.length > 0 && (
                <XIcon
                  className="cursor-pointer text-text-icon-secondary"
                  onClick={() => setSearchValue('')}
                />
              )
            }
          />
        </div>
      </div>

      {/* {searchValue.length === 0 && (
        <div className="flex flex-row overflow-y-auto gap-x-2 pl-4">
          <img
            src="/background/ev.png"
            alt="offer"
            className="rounded-2xl max-h-[122px]"
          />
          <img
            src="/background/ev.png"
            alt="offer"
            className="rounded-2xl max-h-[122px]"
          />
          <img
            src="/background/ev.png"
            alt="offer"
            className="rounded-2xl max-h-[122px]"
          />
          <div className="pr-2">
            <img
              src="/background/ev.png"
              alt="offer"
              className="rounded-2xl max-h-[122px]"
            />
          </div>
        </div>
      )} */}

      <div className="flex flex-col gap-y-4 px-4">
        {isSearching && (
          <p className="text-body-sm-regular text-text-tertiary text-center py-4">Поиск...</p>
        )}
        {!isSearching && displayMenu.length === 0 && debouncedSearch.trim() && (
          <p className="text-body-sm-regular text-text-tertiary text-center py-4">Ничего не найдено</p>
        )}
        {displayMenu.map(item => (
          <div key={item.id} className="grid grid-cols-2 gap-2">
            {item.menu.map(prod => (
              <FoodHomeCard key={prod.id} product={prod} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Search;
